<template>
  <div>
    <output-group-summary
      v-for="(group, index) in groups"
      :key="index"
      :group="group"
      :destination="destination"
      :is-ended="isEnded"
    />
  </div>
</template>

<script>
import OutputGroupSummary from './OutputGroupSummary.vue'

export default {
  name: 'OutputSummary',
  components: {
    OutputGroupSummary,
  },
  props: {
    isEnded: {
      type: Boolean,
      default: false,
    },
    groups: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    destination: {
      type: String,
      default: null,
    },
  },
}
</script>

<style></style>
